

import { Options, Vue } from "vue-class-component";

import LabelAndValue from "@/components/general/LabelAndValue.vue";

import { globalConfig, serviceName, amountHT, amountTTC, paymentDatesOption } from "@/utils";

import SummaryFinancingPartyInsurance from "@/components/summary-panel/SummaryFinancingPartyInsurance.vue";

import store from "@/store";

import { proposalAccessoriesObjectTypes, businessDataUtils } from "@/types";



@Options({

  components: { LabelAndValue, SummaryFinancingPartyInsurance },

  props: ["proposal", "valueStyle", "labelStyle", "divValueStyle"],

})

export default class SummaryFinancingService extends Vue {

  capitalize = globalConfig.capitalize;

  serviceName = serviceName;

  amountHT = amountHT;

  amountTTC = amountTTC;

  paymentDatesOption = paymentDatesOption;

  proposalPartyInsuranceObjectType = proposalAccessoriesObjectTypes.proposalPartyInsuranceObjectType;

  proposalassetinsurance = proposalAccessoriesObjectTypes.proposalassetinsurance;

  proposalsimpleservice = proposalAccessoriesObjectTypes.proposalsimpleservice;

  proposalCommission = proposalAccessoriesObjectTypes.proposalCommission;

  proposalmaintenance = proposalAccessoriesObjectTypes.proposalmaintenance;

  simpleServiceProductItem = proposalAccessoriesObjectTypes.simpleServiceProductItem;

  proposal?: any;



  get calculatestatus() {

    return config.VUE_APP_CALCULATE;

  }



  get offer() {

    return store.state.summaryPanelModule?.offer;

  }



  get isExternalOffer() {

    return this.calculatestatus === "false"

      && this.offer?.businessData?.API === businessDataUtils.offerApiSource;

  }



  /** Même sources que FinancingServices.vue */

  get scalePresentation() {

    const scale =

      store.state.middleOfficeModule?.proposalScale

      ?? store.state.financingModule?.scalesModule?.scaleSelected

      ?? store.state.summaryPanelModule?.proposalScale;

    return scale?.scalePresentation;

  }



  get partyInsurance() {

    let accessories: any[] = [];



    if (this.isExternalOffer) {

      accessories =

        this.proposal?.proposalAccessories?.filter(

          (accessorie: any) =>

            accessorie.objectType.includes(this.proposalPartyInsuranceObjectType)

            || accessorie.objectType.includes(this.proposalassetinsurance)

        ) ?? [];



      const recalcAmountsFromBeneficiaries = (accessory: any) => {

        const beneficiaries = accessory.associatedInsuranceBeneficiaries || [];

        if (beneficiaries.length) {

          accessory.amountWTax = {

            amount: beneficiaries.reduce(

              (sum: number, b: any) => sum + (b?.amountWTax?.amount ?? 0),

              0

            ),

            currency:

              beneficiaries.find((b: any) => b?.amountWTax?.currency)?.amountWTax?.currency

              || accessory?.amountWTax?.currency

              || "EUR",

          };

          accessory.amountWoTax = {

            amount: beneficiaries.reduce(

              (sum: number, b: any) => sum + (b?.amountWoTax?.amount ?? 0),

              0

            ),

            currency:

              beneficiaries.find((b: any) => b?.amountWoTax?.currency)?.amountWoTax?.currency

              || accessory?.amountWoTax?.currency

              || "EUR",

          };

        }

      };



      return accessories.reduce((acc: any[], current: any) => {

        const existingAccessory = acc.find(

          (item) => item.accessoryProduct?.resourceUid === current.accessoryProduct?.resourceUid

        );

        if (existingAccessory) {

          if (current.associatedInsuranceBeneficiaries?.length) {

            existingAccessory.associatedInsuranceBeneficiaries = [

              ...(existingAccessory.associatedInsuranceBeneficiaries || []),

              ...current.associatedInsuranceBeneficiaries,

            ];

          }

          recalcAmountsFromBeneficiaries(existingAccessory);

        } else {

          acc.push({

            ...current,

            associatedInsuranceBeneficiaries: current.associatedInsuranceBeneficiaries || [],

          });

          recalcAmountsFromBeneficiaries(acc[acc.length - 1]);

        }

        return acc;

      }, []);

    }



    return this.scalePresentation?.servicePartyInsurance ?? [];

  }



  get simpleServicesList() {

    if (this.isExternalOffer) {

      return this.proposal?.proposalAccessories?.filter(

        (accessorie: any) =>

          accessorie.objectType.includes(this.proposalsimpleservice)

          || accessorie.objectType.includes(this.proposalmaintenance)

      ) ?? [];

    }

    return this.scalePresentation?.services?.filter(

      (accessorie: any) =>

        accessorie.objectType?.includes(this.simpleServiceProductItem)

        || accessorie.objectType?.includes(this.proposalmaintenance)

    ) ?? [];

  }



  get commissionItems() {

    if (this.isExternalOffer) {

      return this.proposal?.proposalAccessories?.filter((accessorie: any) =>

        accessorie.objectType.includes(this.proposalCommission)

      ) ?? [];

    }

    return this.scalePresentation?.services?.filter((accessorie: any) =>

      accessorie.objectType?.includes(this.proposalCommission)

    ) ?? [];

  }



  /**

   * Blocs tableau comme Financement : assurances puis services simples absents de servicePartyInsurance

   * (ex. PROTECTION PANNE PLUS – ASSISTANCE ROUTE ZEN).

   */

  get serviceTableBlocks() {

    const blocks = [...this.partyInsurance];

    const knownKeys = new Set(blocks.map((item) => this.blockKey(item)).filter(Boolean));



    this.simpleServicesList.forEach((service: any) => {

      const key = this.blockKey(service);

      if (key && !knownKeys.has(key)) {

        blocks.push(service);

        knownKeys.add(key);

      }

    });



    return blocks;

  }



  blockKey(item: any) {

    return item.reference ?? item.accessoryProduct?.resourceUid ?? item.productUid ?? item.resourceUid;

  }



  valueStyle = {

    "font-weight": "bold",

    "margin-left": "20px",

    color: "black",

  };



  divValueStyle = {

    display: "flex",

    "justify-content": "end",

    "padding-right": "10px",

  };

  labelStyleItem = {

    "font-size": "1rem",

    color: "gray",

    "font-weight": "bold",

  };

}

